import type { ApiDocument, ApiFolder } from "@workith/shared";
import type { ReactNode } from "react";
import { DocumentRow } from "./DocumentRow";

interface DocumentListProps {
  documents: ApiDocument[];
  folders?: ApiFolder[];
  onOpenDocument: (document: ApiDocument) => void;
  renderBadge: (document: ApiDocument) => ReactNode;
  renderDescription?: (document: ApiDocument) => ReactNode;
  onDocumentUpdate?: () => void;
}

export function DocumentList({
  documents,
  folders = [],
  onOpenDocument,
  renderBadge,
  renderDescription,
  onDocumentUpdate,
}: DocumentListProps) {
  return (
    <div className="overflow-hidden rounded-lg border bg-card" data-testid="document-list">
      <div className="hidden grid-cols-[minmax(0,1fr)_140px_120px_40px] gap-3 border-b bg-muted/40 px-4 py-2 text-xs font-medium text-muted-foreground md:grid">
        <span>Name</span>
        <span>Status</span>
        <span>Modified</span>
        <span aria-hidden="true" />
      </div>

      {documents.map((documentItem) => (
        <DocumentRow
          key={documentItem.id}
          document={documentItem}
          folders={folders}
          onOpenDocument={onOpenDocument}
          renderBadge={renderBadge}
          renderDescription={renderDescription}
          onDocumentUpdate={onDocumentUpdate}
          rowTestId={`document-list-row-${documentItem.id}`}
          mobileBadgeTestId={`document-list-mobile-badge-${documentItem.id}`}
        />
      ))}
    </div>
  );
}
